import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";
import type { LIST_ERROR_CODES } from "@amtana/list-contract";

// What a user reads when a filter action fails (packages/module ADR-001).

const EN = {
  planRequiredTitle: "Filters aren't available on your plan",
  planRequiredDescription: "Upgrade your plan to use filters.",
  limitReachedTitle: "You've reached your filter limit",
  limitReachedDescription: "Delete a filter or upgrade your plan to create more.",
  notFoundTitle: "This filter doesn't exist",
  notFoundDescription: "It may have been deleted. Open your filters to pick another.",
} as const;

const ES: Translation<typeof EN> = {
  planRequiredTitle: "Los filtros no están disponibles en tu plan",
  planRequiredDescription: "Mejora tu plan para usar filtros.",
  limitReachedTitle: "Llegaste al límite de filtros",
  limitReachedDescription: "Elimina un filtro o mejora tu plan para crear más.",
  notFoundTitle: "Este filtro no existe",
  notFoundDescription: "Puede que se haya eliminado. Abre tus filtros para elegir otro.",
};

export const LIST_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const LIST_ERROR_COPY = {
  list_plan_required: {
    title: phrase(LIST_ERROR_CATALOGS, "planRequiredTitle"),
    description: phrase(LIST_ERROR_CATALOGS, "planRequiredDescription"),
  },
  list_limit_reached: {
    title: phrase(LIST_ERROR_CATALOGS, "limitReachedTitle"),
    description: phrase(LIST_ERROR_CATALOGS, "limitReachedDescription"),
  },
  list_not_found: {
    title: phrase(LIST_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(LIST_ERROR_CATALOGS, "notFoundDescription"),
  },
} satisfies ErrorCopyFor<typeof LIST_ERROR_CODES>;
